import { render, staticRenderFns } from "./ControlFarmacias.vue?vue&type=template&id=1bf8f3e0&scoped=true"
import script from "./ControlFarmacias.vue?vue&type=script&lang=js"
export * from "./ControlFarmacias.vue?vue&type=script&lang=js"
import style0 from "./ControlFarmacias.vue?vue&type=style&index=0&id=1bf8f3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8f3e0",
  null
  
)

export default component.exports